module.exports = __webpack_public_path__ + "img/luxury@2x.bb9230f.webp";